import { InfoCircleOutlined } from '@ant-design/icons';
import { Button, Image, Progress, Tag, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import EditIcon from '../../../assets/images/edit-icon-blue.svg';
import GraduateIcon from '../../../assets/images/graduate-icon.svg';
import HomeIconGrey from '../../../assets/images/home-grey.svg';
import Feedback from '../../../components/common/Feedback';
import ModalBox from '../../../components/common/ModalBox';
import { checkForFeedback, verifyIfUserCountryCodeIsPresent } from '../../../utilities';
import { DefaultProfileIcon, FeedbackImg } from '../../../utilities/resources';
import { EMAIL_VERIFICATION_STEP, MCI_UPLOAD_STEP, STEPS_IN_PROFILE_COMPLETION } from '../../../utilities/appStatics';
import EditProfile from './EditProfile';
import Img from '../../../components/common/Img';
import MCIUpload from '../../../components/common/MCIUpload';

const MAX_QUALIFICATIONS_TO_SHOW_IN_PROFILE = 2;
const INDIA_NAME = 'India';

function LeftSection(props) {
  const { profileStepsCount, userDetails, profileStrength, strengthColor, verifyEmail } = props;
  const [visibleModal, setVisibleModal] = useState(false);
  const [displayNameForZipCode, setDisplayNameForZipCode] = useState('');
  const [viewQualificationsModal, setViewQualificationsModal] = useState(false);
  const [visibleMCIModal, setVisibleMCIModal] = useState(false);
  const [userQualificationArray, setUserQualificationArray] = useState([]);
  const [feedbackModalVisible, setFeedbackModalVisible] = useState(false);

  useEffect(() => {
    if (userDetails && userDetails.users) {
      if (userDetails.users.qualification) {
        setUserQualificationArray(userDetails.users.qualification.split(','));
      }
      if (userDetails.users.location) {
        setDisplayNameForZipCode(userDetails.users.location);
      } else {
        setDisplayNameForZipCode(verifyIfUserCountryCodeIsPresent(userDetails) ? userDetails.users.userCountry.name : INDIA_NAME);
      }
    }
  }, [userDetails]);

  return userDetails.users ? (
    <div className='profile_left fadeIn-up' style={{ animationDelay: '0.15s' }}>
      <ModalBox title='Qualifications' visible={viewQualificationsModal} setVisible={setViewQualificationsModal} className='changeModal'>
        <div>
          <div>
            {userQualificationArray.map((qualification) => {
              return <Tag>{qualification.trim()}</Tag>;
            })}
          </div>
          <div className='changeModal_buttons'>
            <Button onClick={() => setViewQualificationsModal(false)} className='button_default'>
              Cancel
            </Button>
            <Button
              onClick={() => {
                setViewQualificationsModal(false);
                setVisibleModal(true);
              }}
              type='primary'
            >
              Edit
            </Button>
          </div>
        </div>
      </ModalBox>
      <EditProfile visibleModal={visibleModal} setVisibleModal={setVisibleModal} />
      <div className='profile_cover'>
        <Tooltip title={'Edit Details'}>
          <span onClick={() => setVisibleModal(true)} className='profile_edit'>
            <Img src={EditIcon} alt='Edit Icon' />
          </span>
        </Tooltip>
        <div className='profile_picture_box'>
          <div className='media profile_picture'>
            <Image src={userDetails.users.profilePic ? userDetails.users.profilePic : DefaultProfileIcon} alt={userDetails.users.title + userDetails.users.firstName + userDetails.users.lastName} />
          </div>
        </div>
      </div>
      <div className='users'>
        <div className='users_name'>{`${userDetails.users.title} ${userDetails.users.firstName} ${userDetails.users.lastName}`}</div>
        <div className='users_info'>
          {userQualificationArray.length > 0 ? (
            <div className='users_qualifications'>
              <img src={GraduateIcon} alt='Graduate Icon' />
              {userQualificationArray.map((qualification, index) => {
                return <span>{qualification.trim()}</span>;
              })}
            </div>
          ) : (
            ''
          )}
          {displayNameForZipCode ? (
            <div className='users_location'>
              <img src={HomeIconGrey} alt='Home Icon' />
              <span>{displayNameForZipCode}</span>
            </div>
          ) : null}
        </div>
      </div>
      <div className='profile_divider' />
      <div className='profile_body'>
        <div className='heading_title'>
          Profile Strength :{' '}
          <span style={{ color: strengthColor }} className='text_danger'>
            {profileStrength.string}
          </span>
          {profileStrength.string !== 'High' ? (
            <Tooltip title={userDetails.users.incompleteProfileMessage}>
              <span className='profile_strengthInfo'>
                <InfoCircleOutlined />
              </span>
            </Tooltip>
          ) : null}
        </div>
        <div className='profile_strength'>
          <Progress percent={(profileStrength.number / profileStepsCount) * 100} steps={5} strokeColor={strengthColor} trailColor='#D9D7D7' strokeWidth={8} showInfo={false} />
        </div>
        {profileStrength.number === profileStepsCount ? null : (
          <div>
            <div className='heading_title'>Pending Steps:</div>
            {STEPS_IN_PROFILE_COMPLETION.map((step) => {
              if (step.name === MCI_UPLOAD_STEP && verifyIfUserCountryCodeIsPresent(userDetails) && step.forUserCountries.indexOf(userDetails.users.userCountry.code) >= 0) {
                if (userDetails.users.registrationStatus === '1') {
                  return (
                    <Tooltip title={'We will verify your Medical Registration Certificate within 2 business days'}>
                      <p className='profile_pending text_danger'>MCI Under Verification</p>
                    </Tooltip>
                  );
                }
                if (userDetails.users.registrationStatus === '0' || userDetails.users.registrationStatus === '3') {
                  return (
                    <p onClick={() => setVisibleMCIModal(true)} className='profile_pending text_danger'>
                      {userDetails.users.registrationStatus === '3' ? 'Re-' : null}Upload Medical Registration Certificate
                    </p>
                  );
                }
              }
              if (step.name === EMAIL_VERIFICATION_STEP && !userDetails.users.isEmailVerified) {
                return (
                  <p onClick={verifyEmail} className='profile_pending text_danger'>
                    Verify Email Address
                  </p>
                );
              }
            })}
          </div>
        )}

        {checkForFeedback(userDetails) && (
          <div className='feedbackSection'>
            <img className='feedback_image' src={FeedbackImg} />
            <div className='title'>We would love to hear from you</div>
            <Button onClick={() => setFeedbackModalVisible(true)} type='primary'>
              Leave a Feedback
            </Button>
          </div>
        )}
        <Feedback isModalVisible={feedbackModalVisible} setIsModalVisible={setFeedbackModalVisible} />
      </div>
      <MCIUpload MCIUploadModal={visibleMCIModal} setMCIUploadModal={setVisibleMCIModal} bodyStyles={{ textAlign: 'center' }} />
    </div>
  ) : null;
}

export default LeftSection;
